import { useState, useEffect } from 'react';

export function useInIframe() {
  const [isInIframe, setIsInIframe] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    try {
      setIsInIframe(window.self !== window.top);
    } catch {
      setIsInIframe(true);
    }
  }, []);

  return isInIframe;
}
